import { useState, useEffect, useCallback } from 'react';

const useHook = () => {
  // Raw Strapi producto entities (not modeled yet).
  const [options, setOptions] = useState<any[]>([]);
  const [typingTimeout, setTypingTimeout] = useState<ReturnType<typeof setTimeout> | null>(null);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = (_event: React.SyntheticEvent, value: string) => {
    setInputValue(value);
  };

  const saveSearch = (texto: string) => {
    if (!texto) return;
    fetch('/api/busqueda/create', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: { texto } })
    }).catch((err) => console.error('Error al guardar búsqueda:', err));
  };

  const search = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (inputValue) {
      saveSearch(inputValue);
      window.location.href = `/busqueda?q=${encodeURIComponent(inputValue)}`;
    }
  };

  const goToProducto = (producto: any) => {
    const slug = producto?.attributes?.slug;
    if (slug) {
      saveSearch(producto?.attributes?.nombre);
      window.location.href = `/productos/${slug}`;
    }
  };

  const fetchData = useCallback(async (input: string) => {
    if (input.length < 1) return;
    setLoading(true);
    try {
      const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/productos/get-filtered`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre: input,
          page: 1,
          pageSize: 40
        })
      });

      const data = await result.json();
      if (data?.data) {
        setOptions(data.data);
      }
    } catch (err) {
      console.error('Error al buscar:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (typingTimeout) clearTimeout(typingTimeout);

    if (inputValue) {
      const timeout = setTimeout(() => fetchData(inputValue), 300);
      setTypingTimeout(timeout);
    } else {
      setOptions([]);
    }

    return () => {
      if (typingTimeout) clearTimeout(typingTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue, fetchData]);

  return {
    options,
    inputValue,
    loading,
    handleInputChange,
    search,
    goToProducto,
  };
};

export default useHook;
